module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_my_trainings")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "width": "100%",
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/weight.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_scheduled_trainings")))])])]), _vm._v(" "), _c('div', _vm._l((_vm.trainings), function(item) {
    return _c('div', {
      staticClass: "training-item-column middle",
      staticStyle: {
        "background-color": "transparent",
        "height": "50px !important",
        "margin-bottom": "5px",
        "margin-top": "10px"
      }
    }, [_c('div', {
      staticClass: "training-item-column-inner first",
      staticStyle: {
        "height": "50px !important"
      }
    }, [_c('div', {
      staticClass: "my-training-item"
    }, [_c('div', [_c('p', {
      staticClass: "my-training-item-text-title"
    }, [_vm._v(_vm._s(item.date) + "  -  " + _vm._s(item.startAt))])]), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "my-training-item-text-training-type"
    }, [_vm._v(_vm._s(item.trainingType))])])])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner second",
      staticStyle: {
        "height": "50px !important",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTraining(item)
        }
      }
    }, [_c('div', {
      staticClass: "button-cancel-training",
      on: {
        "click": function($event) {
          return _vm.deleteTraining(item)
        }
      }
    }, [_c('p', {
      staticClass: "button-cancel-training-text"
    }, [_vm._v(_vm._s(_vm.locale.t("label_cancel").toUpperCase()))])])])])
  }), 0), _vm._v(" "), (_vm.trainings.length <= 0) ? _c('div', [_c('p', {
    staticClass: "no-trainings"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t("label_no_scheduled_trainings")))])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "margin-top": "20px",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/waiting_list.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_waiting_list")))])])]), _vm._v(" "), _c('div', _vm._l((_vm.waitingList), function(item) {
    return _c('div', {
      staticClass: "training-item-column middle",
      staticStyle: {
        "background-color": "transparent",
        "height": "50px !important",
        "margin-bottom": "5px",
        "margin-top": "10px"
      }
    }, [_c('div', {
      staticClass: "training-item-column-inner first",
      staticStyle: {
        "height": "50px !important"
      }
    }, [_c('div', {
      staticClass: "my-training-item"
    }, [_c('div', [_c('p', {
      staticClass: "my-training-item-text-title"
    }, [_vm._v(_vm._s(item.date) + "  -  " + _vm._s(item.startAt))])]), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "my-training-item-text-training-type"
    }, [_vm._v(_vm._s(item.trainingType))])])])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner second",
      staticStyle: {
        "height": "50px !important",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.unsubscribe(item)
        }
      }
    }, [_c('div', {
      staticClass: "button-cancel-training",
      on: {
        "click": function($event) {
          return _vm.unsubscribe(item)
        }
      }
    }, [_c('p', {
      staticClass: "button-cancel-training-text"
    }, [_vm._v(_vm._s(_vm.locale.t("label_cancel").toUpperCase()))])])])])
  }), 0), _vm._v(" "), (_vm.waitingList.length <= 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "transparent",
      "height": "50px !important",
      "margin-bottom": "20px",
      "margin-top": "25px"
    }
  }, [_c('p', {
    staticClass: "no-trainings"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t("label_waiting_list_is_empty")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "margin-top": "30px",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/icons/waiting_list.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.locale.t("label_training_history")))])])]), _vm._v(" "), _c('div', _vm._l((_vm.historyTrainings), function(item) {
    return _c('div', {
      staticClass: "training-item-column middle",
      staticStyle: {
        "background-color": "transparent",
        "height": "50px !important",
        "margin-bottom": "5px",
        "margin-top": "10px"
      }
    }, [_c('div', {
      staticClass: "training-item-column-inner first",
      staticStyle: {
        "height": "50px !important"
      }
    }, [_c('div', {
      staticClass: "my-training-item"
    }, [_c('div', [_c('p', {
      staticClass: "my-training-item-text-title"
    }, [_vm._v(_vm._s(item.date) + "  -  " + _vm._s(item.startAt))])]), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "my-training-item-text-training-type"
    }, [_vm._v(_vm._s(item.trainingType))])])])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner second",
      staticStyle: {
        "height": "50px !important",
        "cursor": "pointer"
      }
    })])
  }), 0), _vm._v(" "), (_vm.historyTrainings.length <= 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "transparent",
      "height": "50px !important",
      "margin-bottom": "20px",
      "margin-top": "25px"
    }
  }, [_c('p', {
    staticClass: "no-trainings"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t("label_training_history_is_empty")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5812f12a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/MyTrainingsModal.vue
// module id = 769
// module chunks = 0